import cookies from 'js-cookie';

export const isBetaFeaturesOn = (): boolean =>
  cookies.get('development-beta-features') === 'on';
